import get from 'lodash/get';
import * as types from '../actionTypes/SignInSliderActionTypes';

function SignInSliderReducer(state = {}, action = {}) {
    // SIGN IN SLIDER
    switch (action.type) {
        case types.SIGNIN_SLIDER_OPEN: {
            const openCreateAccount = get(action, 'payload.openCreateAccount', false);
            const openLogoutSlider = get(action, 'payload.openLogoutSlider', false) === true;
            const openForgotPasswordSlider = get(action, 'payload.openForgotPasswordSlider', false);
            const isSliderCustomized = get(action, 'payload.isSliderCustomized', false);
            const lnlEnrollPhoneSlider = get(action, 'payload.lnlEnrollPhoneSlider', false);
            const lnlPage = get(action, 'payload.lnlPage', false);
            const postAuthenticationUrl =
                (action.payload && action.payload.postAuthenticationUrl) || undefined;
            const showLoginPage =
                !openCreateAccount &&
                !openLogoutSlider &&
                !openForgotPasswordSlider &&
                !lnlEnrollPhoneSlider;
            const signInSliderFlags = {
                signInDetails: null,
                showWelcomePage: false,
                showAccountMenuPage: false,
                showForgotPasswordPage: false,
                mountSignInSlider: true,
                showLoginPage,
                openCreateAccount,
                openLogoutSlider,
                openForgotPasswordSlider, // to be used to open forgot password page directly
                postAuthenticationUrl,
                lnlEnrollPhoneSlider,
                lnlPage,
                showRewardsPromoLogin: false,
                showWelcomeToolTip: false, // hides tooltip while opening signin slider
                ...(!isSliderCustomized && {
                    customCallbacks: {},
                    customizeConfig: {},
                    isSliderCustomized,
                    prepopulatedForm: {},
                }),
            };
            return { ...state, ...signInSliderFlags };
        }

        case types.SIGNIN_SLIDER_MOUNTED: {
            return { ...state, isSliderOpen: state.mountSignInSlider }; // Sync isSliderOpen to actually open slider
        }

        case types.CUSTOM_STEPUP_SIGNIN_SLIDER: {
            const { customCallbacks, customizeConfig, prepopulatedForm } = action.payload;
            const signInSliderFlags = {
                isSliderCustomized: true,
            };
            return {
                ...state,
                ...signInSliderFlags,
                customizeConfig,
                customCallbacks,
                prepopulatedForm,
            };
        }

        case types.INITIATE_SIGNIN_SLIDER_CLOSE: {
            return { ...state, isSliderOpen: false }; // Close slider
        }

        case types.DISPLAY_ENROLL_PHONE: {
            return {
                ...state,
                lnlEnrollPhoneSlider: true,
                showWelcomePage: false,
                showAccountMenuPage: false,
                showLoginPage: false,
            };
        }

        case types.UNMOUNT_SIGNIN_SLIDER: {
            return {
                ...state,
                mountSignInSlider: state.isSliderOpen,
                lnlEnrollPhoneSlider: false,
                confirmCreateAccountPage: false,
            }; // Unmount SignInSlider from Layout
        }
        case types.SIGNIN_SLIDER_CREATE_ACCOUNT: {
            const signInSliderFlags = {
                openCreateAccount: true,
                showWelcomePage: false,
                showAccountMenuPage: false,
                showRewardsPromoLogin: false,
                openForgotPasswordSlider: false,
            };
            return { ...state, ...signInSliderFlags };
        }

        case types.OPEN_REWARDS_PROMOTIONAL_LOGIN: {
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: false,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
                showLoginPage: false,
                showRewardsPromoLogin: true,
                isSliderOpen: true,
                mountSignInSlider: true,
            };
            return { ...state, ...signInSliderFlags };
        }

        case types.SIGNIN_SLIDER_PASSWORD_RESET: {
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: false,
                showAccountMenuPage: false,
                showRewardsPromoLogin: false,
                openForgotPasswordSlider: true,
            };
            return { ...state, ...signInSliderFlags };
        }
        case types.SIGNIN_SLIDER_POST_SIGNIN_SUCCESS: {
            const signInDetails = action.payload;
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: !action.payload.isSliderCustomized,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
                showWelcomeToolTip: false,
                showRewardsPromoLogin: false,
                authenticationSuccess: true,
                isSliderCustomized: action.payload.isSliderCustomized,
                isQuickScreenEligible: action?.payload?.isQuickScreenEligible,
            };
            return { ...state, signInDetails, ...signInSliderFlags };
        }
        case types.SIGNIN_SLIDER_ACCOUNT_MENU: {
            const signInSliderFlags = {
                showCreateAccountPage: false,
                showWelcomePage: false,
                showAccountMenuPage: true,
                showForgotPasswordPage: false,
                showWelcomeToolTip: false,
                authenticationSuccess: false,
                showRewardsPromoLogin: false,
                mountSignInSlider: true,
                isSliderOpen: true,
                customizeConfig: {},
            };
            return { ...state, ...signInSliderFlags };
        }
        case types.SIGNIN_SLIDER_POST_SIGNIN_ERROR: {
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: false,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
            };
            const signInDetails = action.payload;
            return { ...state, signInDetails, ...signInSliderFlags };
        }
        case types.SIGNIN_SLIDER_CREATE_ACCOUNT_SUCCESS: {
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: true,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
                showRewardsPromoLogin: false,
                authenticationSuccess: true,
                confirmCreateAccountPage: true,
                accountCreatedFromOCP: action?.payload?.accountCreatedFromOCP || false,
            };
            const createAccount = action.payload;
            return { ...state, createAccount, ...signInSliderFlags };
        }
        case types.NATIVE_SIGNIN_SLIDER_CREATE_ACCOUNT_SUCCESS: {
            return { ...state, isNativeCreateAccount: true };
        }
        case types.SIGNIN_SLIDER_CREATE_ACCOUNT_ERROR: {
            const signInSliderFlags = {
                openCreateAccount: true,
                showWelcomePage: false,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
            };
            const createAccount = action.payload;
            return { ...state, createAccount, ...signInSliderFlags };
        }
        case types.SIGNIN_SLIDER_RESET: {
            const signInSliderFlags = {
                openCreateAccount: false,
                showWelcomePage: false,
                showAccountMenuPage: false,
                openForgotPasswordSlider: false,
                createAccount: {},
                signInDetails: null,
                confirmCreateAccountPage: false,
            };
            return { ...state, ...signInSliderFlags };
        }
        // Using Password Reset Action Types, Actions and Reducers for all password reset flow
        // case types.SIGNIN_SLIDER_PASSWORD_RESET_ERROR:
        // case types.SIGNIN_SLIDER_PASSWORD_RESET_SUCCESS: {
        //     const passwordResetResponse = action.payload;
        //     return { ...state, passwordResetResponse };
        // }

        case types.SIGNIN_SLIDER_HIDE_WELCOME_TOOL_TIP: {
            const signInSliderFlags = {
                showWelcomeToolTip: false,
            };
            return { ...state, ...signInSliderFlags };
        }

        case types.SIGNIN_SLIDER_SHOW_LOGOUT_TOOL_TIP: {
            const signInSliderFlags = {
                showWelcomeToolTip: true,
                openLogoutSlider: false,
                mountSignInSlider: false,
                showRewardsPromoLogin: false,
                isSliderOpen: false,
                authenticationSuccess: false,
                isQuickScreenEligible: false,
            };
            return { ...state, ...signInSliderFlags };
        }

        case types.LNL_PAGE_EMAIL_FOCUS: {
            return { ...state, emailFocus: action.payload };
        }

        default:
            return state;
    }
}
SignInSliderReducer.reducerName = 'signInSliderDetails';
export default SignInSliderReducer;
